var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,6.29l-2-2-.71-.29h-3.28l-.77-2.32-.95-.68H8l-.95,.68-.77,2.32H3l-.71,.29L.29,6.29l-.29,.71v11l.29,.71,2,2,.71,.29H21l.71-.29,2-2,.29-.71V7l-.29-.71Zm-1.71,11.29l-1.41,1.41H3.41l-1.41-1.41V7.41l1.41-1.41h3.59l.95-.68,.77-2.32h6.56l.77,2.32,.95,.68h3.59l1.41,1.41v10.17ZM14.71,7.29l-.71-.29h-4l-.71,.29-2,2-.29,.71v4l.29,.71,2,2,.71,.29h4l.71-.29,2-2,.29-.71v-4l-.29-.71-2-2Zm.29,6.29l-1.41,1.41h-3.17l-1.41-1.41v-3.17l1.41-1.41h3.17l1.41,1.41v3.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/1774271343/media/icon-camera.54177d535909d74b5886e3af8b8c71a0.svg";
export { ForwardRef as ReactComponent };